export default __webpack_public_path__ + "static/media/illi11.7b6e5c2b.png";